export const FEEDBACK_LINK = "https://forms.gle/emHCyiVQNm3NXjHc9";
export const GITHUB_LINK = "https://github.com/dan9418/play-what";
export const INSTAGRAM_LINK = "https://www.instagram.com/dan.bednarczyk/";
export const AUTHOR_WEBSITE_LINK = "https://www.danbednarczyk.com/";
